<div class="po-xl-6 po-lg-6 po-md-12 po-sm-12 hourly-sales" id="hourly-sales">
  <po-widget>
    <div style="display: flex; align-items: center; justify-content: space-between;">
      <div style="display: flex; align-items: center;">
        <span class="po-font-text-bold">Vendas por hora</span>
        <span class="po-ml-1 po-icon po-icon-xml pointer-cursor" [p-tooltip]="topTooltipExcel" (click)="downloadExcel()"></span>
      </div>
      <po-select 
        name="viewType" 
        [p-options]="viewOptions" 
        [ngModel]="viewType"
        (ngModelChange)="onViewTypeChange($event)"
        style="width: 150px;">
      </po-select>
    </div>
    <div class="icon-loading" *ngIf="loading && !errorApi">
      <app-loading-icon></app-loading-icon>
    </div>
    <div *ngIf="!loading && errorApi">
      <app-error [message]="message"></app-error>
    </div>
    <div *ngIf="!loading && !errorApi">
      <fusioncharts width="100%" height="310" type="splinearea" [dataSource]="dataSource">
      </fusioncharts>
    </div>
  </po-widget>
</div>